// removed by extract-text-webpack-plugin
module.exports = {"feedback":"feedback--2WYTe","feedbackModal":"feedbackModal--1mmJw","feedbackModalTitle":"feedbackModalTitle--3KpAn","feedbackModalBtn":"feedbackModalBtn--3H-Y8"};